import React from 'react';
import { darken, readableColor } from 'polished';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
`;

const SideBarCategory = (props) => {
    let className = props.className;

    if (props.isInternal) {
        className += ' internal-link';
    }
    if (props.isBeta) {
        className += ' beta-link';
    }

    if (props.isLogout) {
        className += ' logout';
    }

    const { categoryName } = props;

    return (
        <div className={className}>
            <Wrap>
                <span>{categoryName}</span>
            </Wrap>
        </div>
    );
};

SideBarCategory.propTypes = {
    isAccount: PropTypes.bool,
    isActive: PropTypes.bool,
    isInternal: PropTypes.bool,
};

const CategoryContainer = styled(SideBarCategory)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    color: ${props => readableColor(props.theme.global.colors.sideBarColor)};
    font-size: 16px;
    padding: 6px 0 4px 15px;
    text-decoration: none;
    text-transform: uppercase;
    box-sizing: border-box;
    transition: all 200ms ease-in-out;

   
    &.beta-link {
        ::after {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 2px 4px;
            border-radius: 2px;
            margin-left: 5px;
            font-size: 8px;
            background-color: ${props => darken(0.1, props.theme.global.colors.sideBarColor)};
            content: 'BETA';
        }
    }

    &.internal-link {
        ::after {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 2px 4px;
            border-radius: 2px;
            margin-left: 5px;
            font-size: 8px;
            background-color: ${props => darken(0.1, props.theme.global.colors.sideBarColor)};
            content: 'INTERNAL ONLY';
        }
    }

    @media (max-height: 500px) {
        padding: 5px;
        font-size: 12px;
    }
`;

export default CategoryContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/sidebar/SideBarCategory.js